import { Drawer } from "antd";
import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type TDrawerProps = {
  button: any;
  title?: string;
  children?: ReactNode;
  placement?: any;
};

export const GenericDrawer = ({
  title,
  button,
  children,
  placement,
}: TDrawerProps) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // close the drawer
    if (open) setOpen(false);
  }, [location]);

  return (
    <>
      <div onClick={showDrawer}>{button}</div>
      <Drawer
        title={title}
        onClose={onClose}
        placement={placement || "left"}
        open={open}
        bodyStyle={{ padding: 0 }}
        contentWrapperStyle={{ width: 260 }}
      >
        {children}
      </Drawer>
    </>
  );
};
